<template>
  <div class="border-t py-8">
    <div class="flex items-center">
      <div class="relative w-10 h-10 mr-2">
        <img src="/images/yotpo/user.svg" class="w-10 h-10" alt="User picture" width="40" height="40" />
        <img
          v-if="verified"
          src="/images/yotpo/verified.svg"
          class="absolute bottom-0 right-0 w-4 h-4"
          alt="Verified user"
          width="16"
          height="16"
        />
      </div>
      <div class="mt-1 flex-1">
        <div class="leading-none mb-1">{{ question.asker.display_name }}</div>
        <div v-if="verified" class="text-sm leading-none">Verified User</div>
      </div>
      <div class="align-top justify-end">{{ dateToLocaleEnUS(question.created_at) }}</div>
    </div>

    <div class="lg:ml-14 mt-2 lg:w-4/5">
      <div class="font-bold text-sm lg:text-base">
        Q:&nbsp;
        <InlineHtml :text="question.content"></InlineHtml>
      </div>
      <div v-if="answer" class="mt-4 ml-2 lg:ml-6 border-l border-gray pl-2">
        <div class="font-bold text-sm lg:text-base">
          A:&nbsp;
          <InlineHtml :text="answer.content"></InlineHtml>
        </div>
        <div class="text-xs lg:text-sm mt-2">By {{ staffName }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { question } = defineProps<{
  question: YotpoQuestion
}>()

const verified = computed(() => {
  return question.user_type === 'User'
})

const answer = computed(() => {
  if (!(question.sorted_public_answers.length > 0)) return undefined
  return question.sorted_public_answers[0]
})

const staffName = computed(() => {
  if (!answer.value) return undefined
  // Yotpo API returns the display name as "RT Staff" (might be a setting in Yotpo we can change?)
  // so we just convert it to "RealTruck" to match the original Yotpo widget
  return answer.value.answerer.display_name === 'RT Staff' ? 'RealTruck' : answer.value.answerer.display_name
})
</script>
